import { gql } from '@apollo/client';

const LOG_AI_BUG_FINAL_BEAT = gql`
  mutation logAiBugFinalBeat($input: LogAiBugFinalBeatInput!) {
    logAiBugFinalBeat(input: $input) {
      error
      isSuccess
      message
    }
  }
`;

export default LOG_AI_BUG_FINAL_BEAT;
